import { render, staticRenderFns } from "./NotificationUsersDialog.vue?vue&type=template&id=72423cea&scoped=true&"
import script from "./NotificationUsersDialog.js?vue&type=script&lang=js&"
export * from "./NotificationUsersDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72423cea",
  null
  
)

export default component.exports